define('bindingHandlers/inlineDialog',[
    'jquery',
    'lib/lodash4',
    'lib/knockout',
    'util/externalInclude',
    'util/bindingHandlerUtils'
], function (
    $,
    _,
    ko,
    include,
    bindingHandlerUtils
) {
    'use strict';

    var INLINE_DIALOG_TEMPLATE = 'templates/widgets/inlineDialog';

    /**
     * Positions the dialog so that it stays at the top of the screen and does not go past the bottom of the screen.
     * @param { object } element - the inline dialog element that was rendered
     */
    var positionDialog = function (element) {
        var navBarHeight = $('.navbar').height();
        var inlineDialog = $(element);
        var innerBody = inlineDialog.find('.inner-body');
        var inlineDialogTitle = inlineDialog.find('.inline-dialog-title');
        var viewContainer = inlineDialog.find('.view-container');
        var superContainer = inlineDialog.parent().parent();


        // prevent the dialog from taking up more vertical space than is available
        var nonViewContainerHeight = inlineDialogTitle.outerHeight(true) +
                                     (viewContainer.outerHeight(true) - viewContainer.height()) +
                                     (innerBody.outerHeight() - innerBody.height());
        viewContainer.css('max-height', superContainer.height() - nonViewContainerHeight);


        var containerTopOffset = superContainer.offset().top + parseInt(superContainer.css('padding-top'));
        var scrollTop = $(window).scrollTop();

        // if the top of the container hasn't been scrolled past, place the dialog at the top of the container
        if(containerTopOffset > scrollTop + 2 * navBarHeight) {
            inlineDialog.css('top', 0);
        }
        // otherwise, place the container at the top of the page
        else {
            inlineDialog.css('top', scrollTop - containerTopOffset + 2 * navBarHeight);
        }

        // preventing the inline dialog from going past the bottom of the page
        var inlineDialogBottom = inlineDialog.offset().top + innerBody.outerHeight(true);
        var maxTop = Math.max(0, superContainer.height() - innerBody.outerHeight(true));
        var maxBottom = containerTopOffset + superContainer.height();
        if(inlineDialogBottom > maxBottom) {
            inlineDialog.css('top', maxTop);
        }
    };

    /**
     * Initializes positioning of the inline dialog after the template has rendered.
     */
    var positionElementFunc;
    var initializePositioning = function (element) {
        positionDialog(element);

        positionElementFunc = _.partial(positionDialog, element);

        $(window).scroll(positionElementFunc);
        $(window).resize(positionElementFunc);
    };

    /**
     *  <p>html5 inline dialog binding handler</p>
     *
     *  usage:  <div class="inline-dialog-container" data-bind="inlineDialog: InlineDialogView }"
     */
    ko.bindingHandlers.inlineDialog = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var inlineDialogView = ko.unwrap(valueAccessor());
            inlineDialogView = bindingHandlerUtils.decorateWithTemplateContext(inlineDialogView, bindingContext);
            include.loadTemplate(INLINE_DIALOG_TEMPLATE).then(function () {
                ko.renderTemplate(INLINE_DIALOG_TEMPLATE, inlineDialogView, { afterRender: initializePositioning }, element);
            });

            inlineDialogView.showInlineDialog.subscribe(function (showInlineDialog) {
                if (showInlineDialog) {
                    setTimeout(function () { positionDialog($(element).find('.inline-dialog')); }, 100);
                }
            });

            // Cleanup
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                if (positionElementFunc) {
                    $(window).off('resize', positionElementFunc);
                    $(window).off('scroll', positionElementFunc);
                }
            });
        }
    };
});

